import { DateTime } from "luxon";
import { Link } from "react-router-dom"

const Header = ({ call }) => {
    const {
        prospect = {},
        community = {},
    } = call;

    const formatName = ({first_name: firstName, last_name: lastName}) => {
        const capitalize = (str) => {
            if (!str || typeof str !== 'string') return '';
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        return `${capitalize(firstName)} ${capitalize(lastName)}`
    }

    const formatPhoneNumber = (phone) => {
        if (!phone) {
            return '';
        }

        const digits = phone.replace(/\D/g, '').slice(-10); // Keep last 10 digits

        if (digits.length !== 10) {
            return phone;
        }
        const [, area, prefix, line] = digits.match(/(\d{3})(\d{3})(\d{4})/) || [];

        return `(${area}) ${prefix}-${line}`;
    };

    const hasProspectName = !!(prospect?.first_name || prospect?.last_name);
    const hasProspectPhone = !!prospect?.phone_number;
    const hasEmail = !!call?.email_id;

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 px-4 py-3">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                <div className="flex items-center gap-4">
                    <h1 className="text-lg font-semibold text-gray-900">Call Details</h1>
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                        {hasProspectName && <span className="font-medium">{formatName(prospect)}</span>}
                        {hasProspectName && hasProspectPhone && <span>·</span>}
                        {prospect?.phone_number && <span>{formatPhoneNumber(prospect?.phone_number)}</span>}
                    </div>
                </div>
                <div className="flex items-center gap-4 text-sm text-gray-500">
                    <span className="font-mono">ID: {call.id}</span>
                    <span>
                        {DateTime.fromISO(call.created_at).setZone(community?.time_zone).toFormat('MMM d, yy - hh:mm a')}
                    </span>
                    <div className="flex items-center gap-3">
                        <Link
                            to={`/communities/${community.id}`}
                            className="text-blue-600 hover:text-blue-800 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded"
                        >
                            Community
                        </Link>
                        {hasEmail && <span className="text-gray-300">|</span>}
                        {hasEmail && <Link
                            to={`/emails/${call.email_id}`}
                            className="text-blue-600 hover:text-blue-800 font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded"
                        >
                            View Email
                        </Link>}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;